import axios from "axios";

/**
 * QR Loyalty & Ordering — Phase 3. Kitchen display API client.
 *
 * Like the guest client, this is NOT the app's shared axiosInstance: the kitchen
 * page is a standalone, PIN-gated surface with no dashboard session. The PIN is
 * swapped for a scoped kitchen token (see KitchenTokenService) that is sent as a
 * Bearer header on the guarded list/status calls and reaches ONLY the loyalty
 * order routes. Same baseURL (…/api) as the rest of the app.
 */
const client = axios.create({
  baseURL: process.env.REACT_APP_NOT_SECRET_CODE,
  withCredentials: false,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
});

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

/** POST the PIN → { token, expires_in, company_id, venue_name, service_type, orders[] }. */
export const openKitchenSession = (venueCode, pin) =>
  client.post(`/loyalty/kitchen/session`, { venue_code: venueCode, pin }).then((r) => r.data);

/** Live board snapshot (REST fallback; RTDB is the primary feed). */
export const listKitchenOrders = (token) =>
  client.get(`/loyalty/kitchen/orders`, auth(token)).then((r) => r.data?.orders ?? []);

/** Advance an order: new→preparing→ready→picked_up (or cancelled). */
export const setOrderStatus = (token, id, status) =>
  client.put(`/loyalty/kitchen/orders/${encodeURIComponent(id)}/status`, { status }, auth(token)).then((r) => r.data);

export default client;
